module.exports = __webpack_public_path__ + "img/title1.240441b.png";